import { Component, VERSION, OnInit, Injectable} from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { BehaviorSubject } from 'rxjs';
import { AdministrationService } from 'src/app/appServices/administrationService/administrationService.service';
import { MatDialog } from '@angular/material/dialog';
import { ToasterService } from 'src/app/appServices/ToasterService/toaster.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { MenuItemsAccess } from 'src/app/appCommon/Enums/enum';

export class TodoItemNode {
  children!: TodoItemNode[];
  item!: string;
}

export class TodoItemFlatNode {
  item!: string;
  level!: number;
  expandable!: boolean;
  hasChild!: boolean; // new property
}

let TREE_DATA:any = [];



@Injectable({
  providedIn: 'root'
})
export class ChecklistDatabase {
  dataChange = new BehaviorSubject<any[]>([]);
  roleAccessResult: any;
  isAccessRead!: boolean;
  isAccessReadWrite!:boolean;

  // TREE_DATA: any = [];
  get data(): TodoItemNode[] {
    return this.dataChange.value;
  }

  constructor(private administrationService: AdministrationService,private helperService:HelperService ) {
    
    // this.initialize();
  }

  //Getting Tree raw data from database
  GetRCAData(id:any) {
    TREE_DATA = [];
    this.administrationService.GetRCAData(id).subscribe({
      next: (res: any) => {
        res.RCATree.forEach((v: { i: any; },i: any)=>{          
            TREE_DATA.push(v);
            
        });
        this.initialize();
        this.roleAccessResult = JSON.parse(this.helperService.decryption(localStorage.getItem('roleAccessResult')));

        var RCATreeReadWrite = this.roleAccessResult.filter((x:any)=>{return x.com_page_title == MenuItemsAccess.RCATreeReadWrite});

        if(RCATreeReadWrite[0].com_page_title == MenuItemsAccess.RCATreeReadWrite && RCATreeReadWrite[0].cac_isAllowed == true){
          this.isAccessReadWrite = true;
        }else{
          this.isAccessReadWrite = false;
        }

      },
      error: (err: any) => { },
    });
  }

  deleteNode(nodes: TodoItemNode[], nodeToDelete: TodoItemNode) {
    const index = nodes.indexOf(nodeToDelete, 0);
    if (index > -1) {
      nodes.splice(index, 1);
    } else {
      nodes.forEach(node => {
        if (node.children && node.children.length > 0) {
          this.deleteNode(node.children, nodeToDelete);
        }
      });

    }
  }

initialize() {
  //To Map parent & child Node index from key to Text Value  
  let tree =this.RCATree(TREE_DATA)  
  //Tree building from given processed(indexong of child and parent nodes) Data
  const data = this.buildFileTree(tree, 0);   
  
  this.dataChange.next(data);
  
  
}

//To Map parent Node index from key to Text Value
RCATree(nodes:any){  
  const obj = nodes.reduce((h: { [x: string]: any; }, o: { children: any; text: string | number; }) =>(h[o.text] = Object.assign({}, o), h), Object.create(null),[]);
  let helper= this.childrenMapper(obj);
 return helper
}
//To Map Child Node index from key to Text Value
childrenMapper(obj:any){
Object.keys(obj).reduce((h:any, key)=>{
  let current = obj[key].children  
  let type=typeof current
    if(current === '[]') { 
      return
    } else {      
      current=current.reduce((h: { [x: string]: any; }, o: { text: string | number; }) => (h[o.text] = Object.assign({}, o), h),Object.create(null),[]);
      obj[key]=current;   
          if(typeof current=='object'){
          this.childrenMapper(current);
          }
       }
       }, []);  
 return obj
}

//Tree building from given processed(indexong of child and parent nodes) Data

buildFileTree(obj: { [key: string]: any }, level: number): TodoItemNode[] {
  return Object.keys(obj).reduce<TodoItemNode[]>((accumulator, key) => {
    const value = obj[key];
    var node= new TodoItemNode();
    node.item = key;
    
    if (value != null) {
      if (typeof value === 'object') {
        node.children = this.buildFileTree(value, level + 1);
      } else {
        node.item = value;
      }
    }
           return accumulator.concat(node);
  }, []);
}

/** Add an item to to-do list */
insertItem(parent: TodoItemNode, name: string) {
  if (!parent.children) parent.children = [];
  parent.children.push({ item: name } as TodoItemNode);
  this.dataChange.next(this.data);

}

updateItem(node: TodoItemNode, name: string) {
  node.item = name;
  this.dataChange.next(this.data);
}

deleteItem(node: TodoItemNode) {
  this.deleteNode(this.data, node);
  this.dataChange.next(this.data);
}
}
@Component({
  selector: 'app-rca-tree',
  templateUrl: './rca-tree.component.html',
  styleUrls: ['./rca-tree.component.scss']
})
export class RcaTreeComponent implements OnInit {

  workFlow_typeOptions: any = [];
  workFlowType:any=1;
  FormType:any
  addForm:any=FormGroup
  editForm:any=FormGroup
  addDisplay: boolean = false;
  currentNode:any;
  editDisplay: boolean = false;
  selectedPatientDiagramOption:any;
  selectednodeAvailable:any;
  editText:any


  flatNodeMap = new Map<TodoItemFlatNode, TodoItemNode>();

  nestedNodeMap = new Map<TodoItemNode, TodoItemFlatNode>();

  selectedParent: TodoItemFlatNode | null = null;

  newItemName = '';

  treeControl: FlatTreeControl<TodoItemFlatNode>;

  treeFlattener: MatTreeFlattener<TodoItemNode, TodoItemFlatNode>;

  dataSource: MatTreeFlatDataSource<TodoItemNode, TodoItemFlatNode>;


  checklistSelection = new SelectionModel<TodoItemFlatNode>(true /* multiple */);
  constructor(public _database: ChecklistDatabase, 
    public administrationService: AdministrationService,
    private EditDialog: MatDialog,private addDialog: MatDialog,
    private toaster:ToasterService,
    private messageService:MessageService,
    private fb:FormBuilder
    
    ) {
    this.workFlow_typeOptions = [
      { value: '1', name: 'EMS' },
      { value: '2', name: 'Inpatient' },
      { value: '3', name: 'Triage/Walk-In' },
      { value: '4', name: 'ED Onset' },
    ];
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren,
    );
    this.treeControl = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource (this.treeControl, this.treeFlattener);

    _database.dataChange.subscribe(data => {
     
      this.dataSource.data = data;
    });

   
  }

  ngOnInit(): void {    
    this._database.GetRCAData(this.workFlowType);
    this.FormType=this.workFlowType;  
    this.addForm = this.fb.group({
      text: ['',Validators.required],
      PatientDiagram:['',Validators.required],
      nodeAvailable:['',Validators.required]
    });

    this.editForm= this.fb.group({
      text: [this.editText,Validators.required],
      editPatientDiagram:['',Validators.required],
      editNodeAvailable:['',Validators.required]
    });
  }

  PatientDiagramOption=[
    {value:'Activation',label:'Activation'},
    {value:'Assessment Start Time',label:'Assessment Start Time'},
    {value:'Thrombolytic Decision',label:'Thrombolytic Decision'},
    {value:'Thrombolytic Administration',label:'Thrombolytic Administration'},
   ];

  
   nodeAvailable=[
    {value:'1',label:'Yes'},
    {value:'0',label:'No'}
   ];

  getLevel = (node: TodoItemFlatNode) => node.level;

  isExpandable = (node: TodoItemFlatNode) => {return node.expandable};

  getChildren = (node: TodoItemNode): TodoItemNode[] => node.children;

  hasChild = (_: number, _nodeData: TodoItemFlatNode) => {return _nodeData.expandable};

  // hasNoContent = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.item === '';

  transformer = (node: TodoItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.item === node.item ? existingNode : new TodoItemFlatNode();
    flatNode.item = node.item;
    flatNode.level = level;
    flatNode.expandable = !!node.children?.length;
    flatNode.hasChild = !!node.children?.length;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };
  // transformer = (node: TodoItemNode, level: number) => {
  //   const existingNode = this.nestedNodeMap.get(node);
  //   const flatNode =
  //     existingNode && existingNode.item === node.item ? existingNode : new TodoItemFlatNode();
  //   flatNode.item = node.item;
  //   flatNode.level = level;
  //   flatNode.expandable = true;// flatNode.expandable = !!node.children?.length;
  //   flatNode.hasChild = !!node.children?.length;  // add this line. this property will help 
  //   this.flatNodeMap.set(flatNode, node);
  //   this.nestedNodeMap.set(node, flatNode);
  //   return flatNode;
  // };


  /** Whether all the descendants of the node are selected. */
  descendantsAllSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every(child => {
        return this.checklistSelection.isSelected(child);
      });
    return descAllSelected;
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }

  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.forEach(child => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);
  }

  /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
  todoLeafItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }

  /* Checks all the parents when a leaf node is selected/unselected */
  checkAllParentsSelection(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  /** Check root node checked state and change it accordingly */
  checkRootNodeSelection(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every(child => {
        return this.checklistSelection.isSelected(child);
      });
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  /* Get the parent node of a node */
  getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  /** Select the category so we can insert the new item. */
  addNewItem(node: TodoItemFlatNode) {
    const parentNode = this.flatNodeMap.get(node);
    this._database.insertItem(parentNode!, '');
    this.treeControl.expand(node);
  }

  /** Save the node to _database */
  saveNode(node: TodoItemFlatNode, itemValue: string) {
    const nestedNode = this.flatNodeMap.get(node);
    this._database.updateItem(nestedNode!, itemValue);
  }
  
  GetRCTreeDataOnFilter(FormType:any){
    this._database.GetRCAData(this.workFlowType);
    this.FormType=FormType; 
   }
  RemoveItem(node: any) {
    let DataTreeNodeInfo=this.findAllByText(TREE_DATA,node);
    this.administrationService.DeleteRCATree(DataTreeNodeInfo,this.workFlowType).subscribe({
      next: (res: any) => {
        
        this._database.GetRCAData(this.workFlowType)
         this.toaster.itemDeleted();

      },
      error: (err: any) => { },
    });
  const nestedNode: any = this.flatNodeMap.get(node);
    this._database.deleteItem(nestedNode);    
  }
   findAllByText(data:any, element: any):any { 
    var i, f = null; // iterator, found node
    if (Array.isArray(data)) { // if entry object is array objects, check each object
      for (i = 0; i < data.length; i++) {
        f = this.findAllByText(data[i],element);
        if (f) {
          return f;
        }
      }
    } else if (typeof data === 'object') { // standard tree element (one root)
      if (data.text === element.item) {
        return data; // found matching element
      }
    }
    if (data.children != undefined && data.children.length > 0) { // if this is not maching element, search nodes, children (if prop exist and it is not empty)
      return this.findAllByText(data.children, element);
    } else {
      return null; // element does not match and it neither have children
    }
   }  
    updateData(node:any){
      let DataTreeNodeInfo=this.findAllByText(TREE_DATA,node);
      let title=this.editForm.value.text;
      let parent=DataTreeNodeInfo.parent=='#'?0:DataTreeNodeInfo.parent;
      DataTreeNodeInfo.parent=parent;
     this.selectedPatientDiagramOption=this.editForm.value.editPatientDiagram.value.replace(/\s/g, "_");    
      this.administrationService.EditRCATree(DataTreeNodeInfo,title,this.workFlowType,node.level,this.editForm.value.editNodeAvailable.value,this.selectedPatientDiagramOption)
      .subscribe({
        next: (res: any) => {
          this._database.GetRCAData(this.workFlowType)
           this.toaster.itemUpdated();
        },
        error: (err: any) => { },
      });
      
    }
    showEditDialog(node:any) {
      this.currentNode=node;
      this.editDisplay = true;
      this.editText=node.item

  }
    editNode(){
      this.updateData(this.currentNode)
      this.editDisplay = false;
    }


    //Add New Node 
  addTreeNode(){
    this.selectedPatientDiagramOption=this.addForm.value.PatientDiagram.value.replace(/\s/g, "_")
    let newNode:any={};
    newNode.id='0';
    newNode.text=(this.addForm.value.text);
    if(this.currentNode!='#'){
      newNode.parentTitle=(this.currentNode.item).replace(/\s/g, "_")  
    }else{
      newNode.parentTitle='Null'
    }
    newNode.state={opened:true};
    newNode.workflowid=true;
    let b=TREE_DATA;
    let a;    
    if(this.currentNode!='#'){
      a=this.findAllByText(TREE_DATA,this.currentNode); 
      newNode.parent=a.id; 
    }else{
    newNode.parent='0'; 
   }   
    this.administrationService.AddRCATree(newNode,this.workFlowType,this.currentNode!='#'?this.currentNode.level:1,this.addForm.value.nodeAvailable.value,this.selectedPatientDiagramOption)
      .subscribe({
      next: (res: any) => {
        this.toaster.itemAdded;
        this._database.GetRCAData(this.workFlowType)
      },
      error: (err: any) => { },
    });
 }

 saveAddNode(){    
  this.addTreeNode();
  this.addDisplay=false;
 }
 showAddDialog(node:any) {
  this.currentNode=node;
  this.addDisplay = true;
}


deleteTreeNode(data: any) {
 this.currentNode=data;
    this.messageService.clear();
    this.messageService.add({
      key: 'c',
      sticky: true,
      severity: 'custom',
      summary: 'Are you sure you want to delete this item?',
    });
  
}
onConfirm() {
   if (this.currentNode) {
    this.RemoveItem(this.currentNode)
  }
  this.messageService.clear();
}

onReject() {
  this.messageService.clear();
}

}
